import React, { useState } from "react";
import api, { setAuthToken } from "../api";
import "./Login.css";
import logo from "../assets/logo.png";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const resp = await api.post("token/", {
        username: email,
        password,
      });

      // ✅ Set authorization token for API calls
      setAuthToken(resp.data.access);

      // ✅ Store login state in localStorage
      localStorage.setItem("isAuthenticated", "true");
      localStorage.setItem("accessToken", resp.data.access);


      // ✅ Redirect to dashboard
      window.location.href = "/dashboard";
    } catch (err) {
      alert("❌ Login failed. Please check your email and password.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <img src={logo} alt="Logo" className="login-logo" />

        <h2 className="login-title">Member Login</h2>

        <form onSubmit={handleLogin} className="login-form">
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />

          <button type="submit" disabled={loading}>
            {loading ? "Logging in..." : "Login"}
          </button>
        </form>

        <p className="login-footer">
          Don't have an account?{" "}
          <a href="/membership" className="login-link">
            Join Now
          </a>
        </p>
      </div>
    </div>
  );
}
